import { Segment } from 'semantic-ui-react'
import styled from 'styled-components'

export const StyledSegment = styled(Segment)`
background: white !important;
-webkit-box-shadow: none !important;
background-color: rgb(241 245 249) !important;
border: none !important;
border-radius: 1.3rem !important;
box-shadow: none !important;
padding-bottom: 20px !important;
 .column {
  -webkit-box-shadow: none !important;  
   box-shadow: none !important;
 }
 .value {
  margin-top: 10px;
 }
`